import React from 'react';
import { Link } from 'react-router-dom';
import { Card } from '../components/Card';
import { TrustScore } from '../components/TrustScore';
import { exchanges } from '../data/mockData';
export function ExchangesPage() {
  return <div className="min-h-screen bg-slate-50" data-id="element-304">
      <div className="bg-gradient-to-br from-slate-900 to-blue-900 text-white py-12" data-id="element-305">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-306">
          <h1 className="text-4xl font-bold mb-3" data-id="element-307">Top 10 Crypto Exchanges</h1>
          <p className="text-slate-300 text-lg" data-id="element-308">
            Trusted reviews and comprehensive analysis of leading cryptocurrency
            exchanges
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-309">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-310">
          {exchanges.map(exchange => <Link key={exchange.id} to={`/exchange/${exchange.id}`} data-id="element-311">
              <Card className="p-6 h-full" hover data-id="element-312">
                <div className="flex items-start gap-4 mb-4" data-id="element-313">
                  <div className="w-12 h-12 bg-gradient-to-br from-slate-700 to-slate-800 rounded-lg flex items-center justify-center text-white font-bold text-lg flex-shrink-0" data-id="element-314">
                    {exchange.rank}
                  </div>
                  <div className="flex-1" data-id="element-315">
                    <div className="flex items-center justify-between mb-2" data-id="element-316">
                      <h3 className="font-semibold text-xl" data-id="element-317">{exchange.name}</h3>
                      <TrustScore score={exchange.trustScore} size="sm" data-id="element-318" />
                    </div>
                    <p className="text-slate-600 text-sm line-clamp-2" data-id="element-319">
                      {exchange.description}
                    </p>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-4 mb-4" data-id="element-320">
                  <div data-id="element-321">
                    <div className="text-xs text-slate-500 mb-1" data-id="element-322">
                      24h Volume
                    </div>
                    <div className="font-semibold" data-id="element-323">
                      ${(exchange.tradingVolume / 1000000000).toFixed(1)}B
                    </div>
                  </div>
                  <div data-id="element-324">
                    <div className="text-xs text-slate-500 mb-1" data-id="element-325">
                      Supported Coins
                    </div>
                    <div className="font-semibold" data-id="element-326">
                      {exchange.supportedCoins}
                    </div>
                  </div>
                  <div data-id="element-327">
                    <div className="text-xs text-slate-500 mb-1" data-id="element-328">
                      Trading Fee
                    </div>
                    <div className="font-semibold" data-id="element-329">{exchange.tradingFee}</div>
                  </div>
                  <div data-id="element-330">
                    <div className="text-xs text-slate-500 mb-1" data-id="element-331">Reviews</div>
                    <div className="font-semibold" data-id="element-332">
                      {exchange.reviews.length} reviews
                    </div>
                  </div>
                </div>

                <div className="flex flex-wrap gap-2" data-id="element-333">
                  {exchange.features.slice(0, 3).map((feature, index) => <span key={index} className="text-xs bg-slate-100 text-slate-700 px-2 py-1 rounded" data-id="element-334">
                      {feature}
                    </span>)}
                  {exchange.features.length > 3 && <span className="text-xs text-slate-500 px-2 py-1" data-id="element-335">
                      +{exchange.features.length - 3} more
                    </span>}
                </div>
              </Card>
            </Link>)}
        </div>
      </div>
    </div>;
}